<template>
  <div ref="containerEl" class="rte" :class="{ disabled }">
    <div class="toolbar-container">
      <span class="ql-formats">
        <button class="ql-bold"></button>
        <button class="ql-italic"></button>
      </span>
      <span class="ql-formats">
        <button class="ql-header" value="1"></button>
        <button class="ql-header" value="2"></button>
      </span>
      <span class="ql-formats">
        <button class="ql-list" value="ordered"></button>
        <button class="ql-list" value="bullet"></button>
      </span>
      <span class="ql-formats">
        <select class="ql-align"></select>
      </span>
      <span class="ql-formats">
        <!-- <button class="ql-link"></button> -->
        <!-- <button class="ql-image"></button> -->
        <!-- <button class="ql-video"></button> -->
      </span>
    </div>
    <div ref="editorEl" class="rte__editor" :class="editorClass"></div>
  </div>
</template>

<script lang="ts">
export default {
  name: "RTEQuill"
};
</script>

<script setup lang="ts">
import Quill from "quill";
// SEE: https://github.com/Fandom-OSS/quill-blot-formatter/issues/39
import BlotFormatter from "quill-blot-formatter/dist/BlotFormatter";
// import DragAndDropModule from "quill-drag-and-drop-module/src/quill-module";
import { onMounted, ref, watch } from "vue";

import "./Themes/email-theme.scss";

Quill.register("modules/blotFormatter", BlotFormatter || null);
const Block = Quill.import("blots/block");
Block.tagName = "SPAN";
Quill.register(Block, true);

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  modelValue: {
    type: String,
    default: () => ""
  },
  editorClass: {
    type: String,
    default: () => ""
  }
});
const emit = defineEmits(["update:modelValue", "ready"]);
const containerEl = ref<any>(null);
const editorEl = ref<any>(null);
const quillEditor = ref<Quill | null>(null);

/* 
  TODOS:
  - (DONE) Need abilty to drag and drop image from another url.
  - Need API to upload image via CDN. 
  - Variable interpolation for {{ first_name }}, {{ last_name}}, etc
  */
onMounted(() => {
  const editor = new Quill(editorEl.value!, {
    theme: "snow",
    bounds: editorEl.value!,
    modules: {
      toolbar: {
        container: containerEl.value.querySelector(".toolbar-container")
      },
      blotFormatter: {}
      // dragAndDrop: {
      //   draggables: [
      //     {
      //       content_type_pattern: DragAndDropModule.image_content_type_pattern,
      //       tag: "img",
      //       attr: "src"
      //     }
      //   ],
      //   async onDrop(file) {
      //     return "https://munstrography.com/img/gallery/composite/DSC02916-Edit.jpg";
      //     // return DragAndDropModule.utils
      //     //   .getFileDataUrl(file)
      //     //   .then((base64) => {

      //     //   })
      //     //   .then(
      //     //     (response_from_server) => response_from_server.url_of_resource
      //     //   );
      //   }
      // }
    }
  });

  // We have to overwrite the native range because it uses document.getSelection
  // If this is in an iframe, the document needs to be from that iframe, not the root page
  editor.selection.getNativeRange = function () {
    const selection = containerEl.value.getRootNode().getSelection();
    if (selection == null || selection.rangeCount <= 0) return null;
    const nativeRange = selection.getRangeAt(0);
    if (nativeRange == null) return null;
    const range = this.normalizeNative(nativeRange);
    return range;
  };

  editor.on("text-change", () => {
    let content = editorEl.value!.firstChild!.innerHTML.trim();
    if (content === "<span><br></span>") content = "";

    // Disable images for now. This works for copy paste & drag
    editorEl.value.querySelectorAll("img").forEach((el) => {
      el.remove();
    });
    emit("update:modelValue", content);
  });
  quillEditor.value = editor;
  if (props.modelValue) {
    quillEditor.value.root.innerHTML = props.modelValue;
  }
  quillEditor.value!.enable(!props.disabled);
  emit("ready");
});

function setContent(content: string) {
  quillEditor.value!.clipboard.dangerouslyPasteHTML(content);
}

watch(
  () => props.disabled,
  (val) => {
    quillEditor.value!.enable(!val);
  }
);

defineExpose({
  setContent
});
</script>

<style lang="scss">
.rte {
  background: white;
  width: 100%;
  position: relative;
  height: 100%;
  z-index: 0; // Force everything to be relative to the default z-index
  .toolbar-container {
    background: white;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 10;
  }
  .ql-editor {
    padding-top: 60px;
  }
  .ql-toolbar {
    border: 1px solid #c7cfd3;
    border-top-right-radius: 7px;
    border-top-left-radius: 7px;
  }
  .rte__editor {
    border: 1px solid #c7cfd3;
    border-top-right-radius: 7px;
    border-top-left-radius: 7px;
  }
  &.disabled {
    .toolbar-container * {
      opacity: 0.8;
      pointer-events: none;
    }
  }
  // .ql-formats {
  //   .ql-stroke {
  //     stroke: #125aeb !important;
  //   }
  //   .ql-fill {
  //     fill: #125aeb !important;
  //   }
  // }
}
</style>
